import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '@/store/auth'
import { Button, Card, Input } from '@diwata/ironvale'

export function Circles() {
  const api = useAuth((s) => s.api)()
  const qc = useQueryClient()
  const [creating, setCreating] = useState(false)
  const [name, setName] = useState('')
  const [slug, setSlug] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  const { data: circles = [], isLoading } = useQuery({
    queryKey: ['circles'],
    queryFn: () => api.listCircles(),
  })

  function onNameChange(v: string) {
    setName(v)
    setSlug(v.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''))
  }

  async function create() {
    setSaving(true)
    setError('')
    try {
      await api.createCircle(name, slug)
      setCreating(false)
      setName('')
      setSlug('')
      qc.invalidateQueries({ queryKey: ['circles'] })
    } catch (e) {
      setError(String(e))
    } finally {
      setSaving(false)
    }
  }

  return (
    <div>
      <div className="cp-page-header">
        <div>
          <div className="cp-page-title">Circles</div>
          <div className="cp-page-subtitle">Teams and organisations you belong to</div>
        </div>
        {!creating && (
          <Button size="sm" onClick={() => setCreating(true)}>+ Create Circle</Button>
        )}
      </div>

      {creating && (
        <Card style={{ marginBottom: 24 }}>
          <div className="cp-form">
            <div className="cp-field">
              <label className="cp-label">Name</label>
              <Input placeholder="e.g. Limitless Capital" value={name} onChange={(e) => onNameChange(e.target.value)} autoFocus />
            </div>
            <div className="cp-field">
              <label className="cp-label">Slug</label>
              <Input value={slug} onChange={(e) => setSlug(e.target.value)} />
            </div>
            {error && <p className="cp-error">{error}</p>}
            <div style={{ display: 'flex', gap: 8 }}>
              <Button variant="ghost" size="sm" onClick={() => setCreating(false)}>Cancel</Button>
              <Button size="sm" onClick={create} disabled={saving || !name || !slug}>
                {saving ? 'Creating…' : 'Create'}
              </Button>
            </div>
          </div>
        </Card>
      )}

      {isLoading && <p className="cp-empty">Loading…</p>}
      {!isLoading && circles.length === 0 && <p className="cp-empty">No Circles yet.</p>}

      <div className="cp-card-grid">
        {circles.map((c) => (
          <Link key={c.id} to={`/circles/${c.id}`} className="cp-familiar-card">
            <div className="cp-familiar-name">{c.name}</div>
            <div className="cp-page-subtitle">{c.slug}</div>
          </Link>
        ))}
      </div>
    </div>
  )
}
